var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityFollowingIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2768 0.484462C15.5795 0.196255 15.9824 0.0369227 16.4004 0.0400853C16.8183 0.0432478 17.2187 0.208658 17.517 0.501413C17.8154 0.794168 17.9883 1.19137 17.9994 1.6092C18.0104 2.02704 17.8587 2.43282 17.5763 2.74093L9.00168 13.4645C8.85423 13.6233 8.67628 13.7508 8.47846 13.8392C8.28064 13.9277 8.06701 13.9754 7.85034 13.9794C7.63368 13.9834 7.41843 13.9437 7.21747 13.8626C7.01651 13.7815 6.83396 13.6608 6.68074 13.5075L0.994434 7.82121C0.83608 7.67365 0.709068 7.49572 0.620976 7.29801C0.532883 7.1003 0.485514 6.88687 0.481696 6.67046C0.477878 6.45405 0.517688 6.23908 0.598751 6.03839C0.679814 5.8377 0.80047 5.65539 0.953521 5.50234C1.10657 5.34929 1.28888 5.22863 1.48957 5.14757C1.69027 5.06651 1.90523 5.0267 2.12164 5.03051C2.33806 5.03433 2.55148 5.0817 2.74919 5.16979C2.9469 5.25789 3.12484 5.3849 3.27239 5.54325L7.77244 10.0411L15.236 0.531741C15.2494 0.515196 15.2638 0.499411 15.279 0.484462H15.2768Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFollowingIconColor);
export default __webpack_public_path__ + "static/media/activity-following-icon-color.412724fdc9fecc38aa6871642bb74d1c.svg";
export { ForwardRef as ReactComponent };